import React from "react";
import "./FundraiserHeader.css";

import footballIcon from "./football.png";
import basketballIcon from "./basketball.png";
import baseballIcon from "./baseball.png";
import soccerIcon from "./soccer.png";
import cheerIcon from "./cheer.png";
import softballIcon from "./softball.png";
import schoolIcon from "./school.png";

import genericIcon from "./generic.png";
import { FundraiserCodeResponse } from "../../Interfaces/Fundraiser";
import config from "../../config";

interface FundraiserComponentProps {
  fundraiser: FundraiserCodeResponse | null;
}

const keywordIconMap: Record<string, string> = {
  football: footballIcon,
  basketball: basketballIcon,
  baseball: baseballIcon,
  soccer: soccerIcon,
  cheer: cheerIcon,
  softball: softballIcon,
  school: schoolIcon,
};

export function getIconFromPurpose(purposeMessage?: string | null): string {
  if (!purposeMessage) return genericIcon;

  const match = Object.entries(keywordIconMap).find(([keyword]) =>
    purposeMessage.toLowerCase().includes(keyword)
  );

  return match ? match[1] : genericIcon;
}

export function getBackgroundIconFromPurpose(
  purposeMessage?: string | null
): string {
  if (!purposeMessage) return "";

  const match = Object.entries(keywordIconMap).find(([keyword]) =>
    purposeMessage.toLowerCase().includes(keyword)
  );

  return match ? match[1] : "";
}

const FundraiserHeaderComponent: React.FC<FundraiserComponentProps> = ({
  fundraiser,
}) => {
  const icon = getIconFromPurpose(fundraiser?.fundraiser_purpose_message);
  const textColor = fundraiser?.primary_color || "#000000";

  return (
    <div className="fundraiser-signup-header-container">
      {/* Top row: Icon + Org Name (left), Org Logo (right) */}
      <div className="fundraiser-signup-header-top">
        <div className="fundraiser-signup-header-left">
          <img
            src={icon}
            alt="Fundraiser Icon"
            className="fundraiser-signup-header-icon"
          />
          <h1
            className="fundraiser-signup-header-org"
            style={{ color: textColor }}
          >
            {fundraiser?.org_name || "Fundraiser Name"}
          </h1>
        </div>

        <img
          src={fundraiser?.org_logo_location || ""}
          alt="Organization Logo"
          className="fundraiser-signup-header-top-right-image"
        />
      </div>

      {/* Bottom text */}
      <div className="fundraiser-signup-header-bottom">
        <h2
          className="fundraiser-signup-header-title"
          style={{ color: textColor }}
        >
          {`${fundraiser?.fundraiser_name} Fundraiser` || "Fundraiser Title"}
        </h2>

        <p
          className="fundraiser-signup-header-thanks"
          style={{ color: textColor }}
        >
          Thank you for your support!
        </p>
      </div>
    </div>
  );
};

export default FundraiserHeaderComponent;
